export default "__VITE_ASSET__2Td5VXKI__"